<template>
  <div class="znews dbborder prelative cpointer ofhidden trans3 pr10" @click="goDetail(item.id)">
    <div class="pabsolute vcenter dt tcenter fbold">
      <div class="fs30 mm">{{day}}</div>
      <div class="fs16">{{month}}</div>
    </div>
    <div class="txt pt25">
      <div class="nm dinline-block vcenter lh17 fs18 ofhidden">
        {{item.title}}
      </div>
      <div class="fs15 tcaa">
        <span>来源：{{item.origin}}</span>
        <span class="ml10 mr15">|</span>
        <span class="read pl20 dinline-block">浏览：{{item.views_count}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "item",
    data(){
      return {
        day:'01',
        month:'12'
      }
    },
    props:[
      'item',
      'index',
    ],
    methods:{
      goDetail (id){
        let path = `/notice/detail?id=${id}` 
        let routeData = this.$router.resolve({
            path
        })
        window.open(routeData.href, '_blank')
        //this.$router.push({path:'/notice/detail',query:{id:id}})
      },
      updateMD(){
        var date = new Date(this.item.release_time);
        var dateTime = date.getTime() / 1000;
        this.month = this.$request.date('Y-m',dateTime);
        this.day = this.$request.date('d',dateTime);
      },
    },
    mounted() {
      this.updateMD();
    },
    updated() {
      this.updateMD();
    },
  }
</script>

<style scoped>
  .znews:hover{background: #f7f7f7;}
  .znews{height: 135px;}
  .znews:last-child{margin-bottom: 0;}
  .znews .txt{padding-left: 120px;}
  .znews .nm{margin-bottom: 35px;height: 30px;color: #444;}
  .znews .dt{top: 20px;width: 96px;height: 96px;background: #ececec;color: #9e9e9e;}
  .znews .mm{margin-bottom: 8px;line-height: 60px;background: #e1e1e1;color: #5a5a5a;}
  .znews .read{background: url(../../../assets/images/cn2.png) no-repeat -8px -5px;}
</style>



// WEBPACK FOOTER //
// src/components/main/notice/item.vue